export enum RouterPaths {
    HOME = "/",
    LOGIN = "/login",
    REGISTRATION = "/registration",
    FORGOTPASSWORD = "/forgot-password",
    RESETPASSWORD = "/reset-password",
    CREATENEWPASSWORD = "/create-new-password",
    TWOFACTORAUTHENTICATION = "/two-factor-authentication",
    DASHBOARD = "/dashboard",
    EDUACTIONALINSTITUTE = "/educational-institute",
    INSTITUTESETTINGS="/institute-settings",
    USERACCESSCONTROL = "/user-access-control",
    ROLE = "/role",
    PERMISSIONS= "/permissions",
    EXPIREALLPASSWORDS = "/expire-all-passwords",
    ACTIONHISTORY = "/action-history",
    EDUCATIONALDEGREES = "/educational/degrees",
    LEARNINGFORMAT = "/learning/format",
    FACULTY="/faculty",
    PROFESSION="/profession",
    ACADEMICDEPARTMENT="academic/department",
    SUBJECT="/subject",
    ACADEMICTERM="/academic/term",
    ACADEMICYEAR="/academic/year",
    STUDYYEARS="/study/years",
    TEACHINGTYPE="/teaching/type",
    SUBJECTCHECKTYPE="/subject/check/type",
    BASELINEDATA="/baseline/data",
    BASELINEDATASETTING="/baseline/data/setting",
    QUALIFICATION="/qualification",
    MODULARSUBJECT="/modular/subject",
    PASSWORDPOLICIES="/password/policies",
    EXPIREALLPASSWORD="/expire/allpassword",
    INSTITUTIONALPREFERENCES="/institutional/preferences",
    LEARNINGPLAN="/learning/plan",
    LEARNINGPLANTRASH="/learning/plan/restore",
    LEARNINGPLANSETTINGS = "/learning/plan/settings",
    LEARNINGPLANINFORMATION="/learning/plan/information",
    BASELINE="/baseline",
    LANGUAGES="/languages",
    TRANSLATIONS="/translations",
    EDUCATIONALBLOCKS="/educational/blocks",
    EDUCATIONALSETTINGS="/educational/settings",
    COMPETENCES="/competences",
    COMPETENCESSETTINGS="/competences/settings",
    EDUCATIONALSECTORS = "/educational/sectors",
    EMPLOYEES="/employees",
    EMPLOYEESSETTINGS="/employees/settings",
    EMPLOYEESOVERVIEW ='/employees/overview',
    ROLESASSOCIATIONS ="/roles/associations",
    ACADEMICSTRUCTURE="/academic/structure",
    WORKLOAD ="/workload",
    WORKLOADSETTINGS="/workload/settings",
    ACADEMICPOSITIONS="/academic/positions",
    ACADEMICSCHEDULING="/academic/scheduling",
    EDUCATIONALDURATION="/educational/duration",
    BASELINEITEMS="/baseline/items",
    SUBJECTGROUPS='/subject/groups',
    POSITIONSWORKINGHOURS="/position/working/hours",
    STUDENTS="/students",
    STUDYPAYMENTOPTIONS="/study/payment/options",
    STUDENTSSETTINGS='/students/settings',
    STUDENTSOVERVIEW="/students/overview",
    UNITEDLESSONS="/united/lessons",
    UNITEDITEM="/united/item",
    WORKLOADITEM="/baseline/item",
    ACADEMICSTRUCTURESETTINGS="/academic/structure/settings",
    ELECTIVESUBJECTS="/elective/subjects",
    ELECTIVEITEM='/elective/item',
    PAGE_NOT_FOUND = "*",
}
